<div class="user-details-wrapper">
  @if (!userDetails()) {
    <div class="loading">
      <nz-spin nzSimple nzSize="large" nzTip="Ładowanie danych użytkownika..." />
    </div>
  } @else {
    @if (userDetails(); as user) {
      <div class="user-view">
        <!-- HERO CARD -->
        <nz-card class="profile-card" [nzBordered]="false">
          <div class="profile-header">
            <nz-avatar class="profile-avatar" nzSize="large" [nzText]="initials()"></nz-avatar>

            <div class="profile-info">
              <h1 class="profile-name">
                {{ user.firstName }}
                {{ user.secondName }}
                {{ user.lastName }}
              </h1>

              <div class="profile-meta">
                <nz-tag nzColor="gold">
                  <span nz-icon nzType="crown"></span>
                  {{ user.roleName }}
                </nz-tag>
                <span class="login-badge">
                  <span nz-icon nzType="user"></span>
                  {{ user.ssoLogin }}
                </span>
              </div>

              <div class="contact-line">
                <span class="contact-item">
                  <span nz-icon nzType="mail"></span>
                  {{ user.email }}
                </span>
                @if (user.phone) {
                  <span class="contact-item">
                    <span nz-icon nzType="phone"></span>
                    {{ user.phone }}
                  </span>
                }
              </div>
            </div>
          </div>
        </nz-card>

        <!-- MAIN GRID: dane osobowe + uprawnienia -->
        <div class="content-grid">
          <!-- DANE OSOBOWE -->
          <nz-card class="form-card" [nzBordered]="false">
            <div class="card-section-header">
              <span nz-icon nzType="idcard" nzTheme="outline" class="section-icon"></span>
              <span>Dane osobowe</span>
            </div>

            <div class="details-grid">
              <div class="detail-item">
                <span class="detail-label"> <span nz-icon nzType="user"></span> Imię </span>
                <span class="detail-value">{{ user.firstName || '-' }}</span>
              </div>

              <div class="detail-item">
                <span class="detail-label"> <span nz-icon nzType="user"></span> Nazwisko </span>
                <span class="detail-value">{{ user.lastName || '-' }}</span>
              </div>

              <div class="detail-item">
                <span class="detail-label"> <span nz-icon nzType="user"></span> Drugie imię </span>
                <span class="detail-value">{{ user.secondName || '-' }}</span>
              </div>

              <div class="detail-item">
                <span class="detail-label"> <span nz-icon nzType="trademark"></span> Tytuł </span>
                <span class="detail-value">{{ user.title || '-' }}</span>
              </div>

              <div class="detail-item">
                <span class="detail-label"> <span nz-icon nzType="mail"></span> Email </span>
                <span class="detail-value">{{ user.email }}</span>
              </div>

              <div class="detail-item">
                <span class="detail-label"> <span nz-icon nzType="phone"></span> Telefon </span>
                <span class="detail-value">{{ user.phone || '-' }}</span>
              </div>

              <div class="detail-item">
                <span class="detail-label">
                  <span nz-icon nzType="profile"></span> Typ identyfikatora
                </span>
                <span class="detail-value">{{ identityTypeDesc() }}</span>
              </div>

              <div class="detail-item">
                <span class="detail-label">
                  <span nz-icon nzType="number"></span> Numer identyfikatora
                </span>
                <span class="detail-value">{{ user.identifierValue || '-' }}</span>
              </div>

              <div class="detail-item">
                <span class="detail-label">
                  <span nz-icon nzType="solution"></span> Numer licencji
                </span>
                <span class="detail-value">{{ user.licenceNumber || '-' }}</span>
              </div>

              <div class="detail-item">
                <span class="detail-label">
                  <span nz-icon nzType="medicine-box"></span> Specjalizacja
                </span>
                <span class="detail-value">{{ user.specialisation || '-' }}</span>
              </div>
            </div>
          </nz-card>

          <!-- UPRAWNIENIA -->
          <nz-card class="form-card" [nzBordered]="false">
            <div class="card-section-header">
              <span
                nz-icon
                nzType="safety-certificate"
                nzTheme="outline"
                class="section-icon"
              ></span>
              <span>Uprawnienia</span>
            </div>

            <div class="permission-section">
              <div class="permission-label">
                <span nz-icon nzType="crown"></span> Rola aplikacyjna
              </div>
              <div class="tags">
                <nz-tag nzColor="processing">{{ user.roleName }}</nz-tag>
              </div>
            </div>

            <div class="permission-section">
              <div class="permission-label"><span nz-icon nzType="team"></span>Role dostępowe</div>
              <div class="tags">
                @for (role of roleNames(); track role) {
                  <nz-tag nzColor="blue">{{ role }}</nz-tag>
                } @empty {
                  <span class="empty-label">Brak</span>
                }
              </div>
            </div>

            <div class="permission-section">
              <div class="permission-label"><span nz-icon nzType="shop"></span> Firmy</div>
              <div class="tags">
                @for (company of claimList('mhs.scm.companies'); track company) {
                  <nz-tag>{{ company }}</nz-tag>
                } @empty {
                  <span class="empty-label">Brak</span>
                }
              </div>
            </div>

            <div class="permission-section">
              <div class="permission-label"><span nz-icon nzType="global"></span> Tenanci</div>
              <div class="tags">
                @for (tenant of claimList('mhs.scm.tenants'); track tenant) {
                  <nz-tag nzColor="green">{{ tenant }}</nz-tag>
                } @empty {
                  <span class="empty-label">Brak</span>
                }
              </div>
            </div>

            <div class="permission-section">
              <div class="permission-label"><span nz-icon nzType="appstore"></span> Moduły</div>
              <div class="tags">
                @for (module of moduleNames(); track module) {
                  <nz-tag nzColor="purple">{{ module }}</nz-tag>
                } @empty {
                  <span class="empty-label">Brak</span>
                }
              </div>
            </div>
          </nz-card>
        </div>

        <!-- PLACÓWKI -->
        <nz-card class="form-card" [nzBordered]="false">
          <div class="card-section-header">
            <span nz-icon nzType="bank" nzTheme="outline" class="section-icon"></span>
            <span>Dostępne placówki</span>
            <nz-tag nzColor="processing" style="margin-left: auto; font-weight: 500">
              {{ user.units?.length || 0 }}
            </nz-tag>
          </div>

          <div class="units-grid">
            @for (unit of user.units; track unit.id) {
              <div class="unit-card">
                <span nz-icon nzType="environment" class="unit-icon"></span>
                <span>{{ unit.name }}</span>
              </div>
            } @empty {
              <span class="empty-label">Brak przypisanych placówek</span>
            }
          </div>
        </nz-card>
      </div>

      <!-- FOOTER -->
      <div class="button-footer-wrapper">
        <a nz-button nzType="default" routerLink="/users">
          <span nz-icon nzType="arrow-left"></span>
          Wstecz
        </a>
      </div>
    }
  }
</div>
